import { render, staticRenderFns } from "./perfilEmpresarialAdd.vue?vue&type=template&id=27ecdc81&"
import script from "./perfilEmpresarialAdd.vue?vue&type=script&lang=js&"
export * from "./perfilEmpresarialAdd.vue?vue&type=script&lang=js&"
import style0 from "./perfilEmpresarialAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports